export const editDonorSchema = {
  fields: [
    {
      name: 'fullName',
      label: 'Full Name',
      type: 'text',
      placeholder: 'Enter full name',
      required: true,
    },
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      required: true,
    },
    {
      name: 'mobile',
      label: 'Mobile Number',
      type: 'prefixInput',
      required: true,
      placeholder: '123 456 7890',
      options: [
        { label: 'US +1',  value: '+1' },
        { label: 'UK +44', value: '+44' },
      ]
    }
  ],
  buttons: [
    {
      label: 'Cancel',
      action: 'cancel',
      type: 'button',
      className: 'btn-danger',
    },
    {
      label: 'Update',
      action: 'update',
      type: 'button',
      className: 'btn-next',
    },
  ],
};